import MediaZoomWithCredits from "../../shared/media-zoom.min";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Initialize MediaZoom when the controller connects
    // Pass any options or configuration as needed
    const options = {
      videoWidth: "80vw",
      videoHeight: "50vh",
      videoAutoplay: true,
      enableNavigation: true,
      enableKeyboardNav: true,
    };
    this.mediaZoom = new MediaZoomWithCredits(options);
    // Force creation of elements on initialization
    if (!this.mediaZoom.elementsCreated) {
      this.mediaZoom.createElements();
    }
    // // Hide the elements but keep them in DOM
    if (this.mediaZoom.container) {
      this.mediaZoom.container.style.display = "none";
    }
  }

  disconnect() {
    // Clean up MediaZoom when the controller disconnects
    if (this.mediaZoom && typeof this.mediaZoom.destroy === "function") {
      this.mediaZoom.destroy();
    }
    this.mediaZoom = null;
  }
}
